module.exports = __webpack_public_path__ + "static/media/evenbreeze-4.2398674b.jpg";